module.exports = __webpack_public_path__ + "img/FR14265.db1ab54b.png";